module.exports = __webpack_public_path__ + "img/caret-fill.b2052858.svg";